interface TimeGridEventProps {
  calendarEvent: any
}

import { User } from 'lucide-react'

export function TimeGridEvent({ calendarEvent }: TimeGridEventProps) {
  // const start = new Date(calendarEvent.start)
  // const end = new Date(calendarEvent.end)

  const { calendarId: color, title, id, data } = calendarEvent
  const cashfitFields = data as any

  return (
    <div className="" style={{backgroundColor: color || 'grey', minHeight: 180 }} key={id}>
      <div className="text-xs font-bold ml-1">{title}</div>
      <div className="flex flex-col items-start">
        <span className='pl-1'>{`Sala: ${cashfitFields.nomeSala} - Nº ${cashfitFields.numeroSala}`}</span>
        <div className="flex gap-2 items-center">
          <User height={14} />
          <span>{`${cashfitFields.quantidadeAlunosInscritos} / ${cashfitFields.capacidadeMaxima}`}</span>
        </div>
      </div>
    </div>
  )
}
